export default __webpack_public_path__ + "static/media/CapitalFundLogo.73cd5668.png";